<template>
  <div>
    <el-table
      v-if="showTable"
      :data="nameList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :index="(index) => indexMethod(index, page, pageSize)"
        :width="
          widthMax < 767.98
            ? '80'
            : widthMax < 1150
            ? '60'
            : widthMax > 1199.98
            ? '80'
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="nameTH"
        label="ชื่อ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '140'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? ''
            : widthMax > 1199.98
            ? ''
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="surnameTH"
        label="นามสกุล"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '140'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? ''
            : widthMax > 1199.98
            ? ''
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="ชื่อบริษัท"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '130'
            : widthMax > 1199.98
            ? ''
            : ''
        "
        sortable
      ></el-table-column>
      <el-table-column
        prop="mobilephone"
        label="เบอร์โทรศัพท์"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '130'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '120'
            : ''
        "
      ></el-table-column>
      <el-table-column
        v-if="showEmail == true"
        prop="email"
        label="อีเมล"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '130'
            : widthMax > 1199.98
            ? ''
            : ''
        "
        sortable
      ></el-table-column>
      <el-table-column
        v-if="labelScore"
        prop="score"
        :label="labelScore"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '200'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '150'
            : widthMax > 1199.98
            ? ''
            : ''
        "
      >
        <template slot-scope="scope">
          <div v-if="Date.now() < new Date(scope.row.score.open).getTime()">
            <sapn  class="color-gray">
              วิชายังไม่เปิด
            </sapn>
          </div>
          <div v-if="scopeField == 'preTest'">
            <span v-if="scope.row.score.preTestDone">
              {{ scope.row.score.preTestScore}}/{{ scope.row.score.preTestTotal}}
            </span>
            <span v-else class="color-danger-lighter">
              ยังไม่ได้ทำข้อสอบ
            </span>
          </div>
          <div v-if="scopeField == 'postTest'">
            <span v-if="scope.row.score.postTestDone">
              {{ scope.row.score.postTestScore}}/{{ scope.row.score.postTestTotal}}
            </span>
            <span v-else class="color-danger-lighter">
              ยังไม่ได้ทำข้อสอบ
            </span>
          </div>
          <div v-if="scopeField == 'discussion'">
            <span v-if="scope.row.score.discussion" class="pd-x-4 color-success">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="color-danger-lighter">ยังไม่ได้ตอบคำถาม</span>
          </div>
          <div v-if="scopeField == 'assignment'">
              <span v-if="scope.row.score.takeAssignment == false" class="color-danger-lighter">ยังไม่ได้ส่ง</span>
              <el-checkbox
                v-else
                @change="checkAssignment(scope.row._id,scope.row.score._id, scope.row.score.assignment)"
                :value="scope.row.score.assignment ==0?false:true"
              ></el-checkbox>
          </div>
          <div v-if="scopeField == 'topic'">
            <span v-if="scope.row.score.topic >= 100" class="pd-x-4 color-success">
              <i class="fas fa-check"></i>
            </span>
            <span v-else-if="scope.row.score.takeTopic" class="color-warning">กำลังเรียน</span>
            <span v-else class="color-danger-lighter">ยังไม่ได้เรียน</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :prop="dateObj"
        :label="dateLabel"
        :width="
          widthMax < 767.98
            ? '200'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '200'
            : widthMax > 1199.98
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row[dateObj] | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="scopeField == 'assignment'"
        label
        width="50"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <a
                target="_blank"
                :href="
                user.role == 50 ? `/view/assigment?edit=${false}&courseId=${courseId}&subjectId=${subjectId}&userId=${scope.row._id}`
                :`/activity/assigment?edit=${false}&courseId=${courseId}&subjectId=${subjectId}&userId=${scope.row._id}`"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </a>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    nameList: {
      type: Array,
      default() {
        return [];
      },
    },
    dateLabel: {
      type: String,
      default() {
        return "วันที่และเวลาที่อัปเดต";
      },
    },
    dateObj: {
      type: String,
      default() {
        return "updatedAt";
      },
    },
    labelScore: {
      type: String,
      default() {
        return "";
      },
    },
    scopeField: {
      type: String,
      default() {
        return "";
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    subjectId: {
      type: String,
      default() {
        return "";
      },
    },
    showEmail: {
      type: Boolean,
      default() {
        return false;
      },
    },
    pageSize:{
      type:Number,
      default(){
        return 0
      }
    },
    page:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  computed: {
    user(){
      return this.$store.state.user
    }
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
    setTimeout(() => {
      this.showTable = true
    }, 200);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    checkAssignment(userId,subjectId, status) {
      this.$emit("checkAssignment", userId,subjectId, status);
    },
  },
};
</script>